const SIDEBAR_NOTIFICATIONS = 'notifications';

export default SIDEBAR_NOTIFICATIONS;
